import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.85",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M14.2 4.15a4.7 4.7 0 0 0-5.95 5.94L3.6 14.74a2.1 2.1 0 0 0 2.97 2.97l4.65-4.65a4.7 4.7 0 0 0 5.94-5.95l-2.5 2.5-2.25-.58-.58-2.25 2.37-2.63ZM4.95 16.36h.01" }, null, -1)
  ]))]))
}
export default { render: render }